var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5877_92957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.1402 0 0 3.14024 0 7.00004C0 10.8598 3.1402 14 7 14C10.8598 14 14 10.8598 14 7.00004C14 3.14024 10.8598 0 7 0ZM7 12.7273C3.84194 12.7273 1.27273 10.1581 1.27273 7.00004C1.27273 3.84202 3.84194 1.27273 7 1.27273C10.1581 1.27273 12.7273 3.84202 12.7273 7.00004C12.7273 10.1581 10.158 12.7273 7 12.7273Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00005 2.9707C6.53228 2.9707 6.15173 3.3515 6.15173 3.81957C6.15173 4.28721 6.53228 4.66767 7.00005 4.66767C7.46782 4.66767 7.84836 4.28721 7.84836 3.81957C7.84836 3.3515 7.46782 2.9707 7.00005 2.9707Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00001 5.93945C6.64857 5.93945 6.36365 6.22437 6.36365 6.57582V10.394C6.36365 10.7454 6.64857 11.0304 7.00001 11.0304C7.35145 11.0304 7.63637 10.7454 7.63637 10.394V6.57582C7.63637 6.22437 7.35145 5.93945 7.00001 5.93945Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5877_92957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.5b0c1049adccfe515125f23b746f88bd.svg";
export { ForwardRef as ReactComponent };